import React, { type ReactNode } from 'react';
import {
  Link as ReactRouterLink,
  LinkProps as ReactRouterLinkProps,
} from 'react-router-dom';
import { Icon, IconName } from '@storebrand-digital/pretzel/icons';
import styles from './Link.module.css';

interface Props extends ReactRouterLinkProps {
  $bold?: boolean;
  icon?: IconName;
  iconSize?: number;
  children?: ReactNode;
}

function RouterLink({
  $bold = false,
  icon,
  iconSize = 16,
  children,
  className,
  ...props
}: Props) {
  // Render a bare React Router anchor styled via linkBase (text-decoration: none),
  // matching the pre-migration `styled(Link) as={ReactRouterLink}` which bypassed
  // Pretzel's Link. Routing through Pretzel's Link wraps children in an underlined
  // `.linkText` span, which incorrectly underlines the subtext rows.
  return (
    <ReactRouterLink
      {...props}
      data-bold={$bold ? 'true' : undefined}
      className={[styles.linkBase, className].filter(Boolean).join(' ')}
    >
      {icon && <Icon name={icon} size={iconSize} />}
      <div>{children}</div>
    </ReactRouterLink>
  );
}

export default RouterLink;
